import * as _ from 'lodash'
import axios from 'axios'
import * as AsyncLock from 'async-lock'

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ITableauTokenResponse, ITableauTokenRequest} from "../../common/PA.Core/PA.Core.IF.Session"
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {IReportingService} from "../PA.Reporting.Core/PA.Reporting.IF"


export class PAReportTokenService
    implements IReportingService {
    private _type: string

    constructor(sType: string) {
        this._type = sType

    }


    private makeTableauRequest(aRequest: ITableauTokenRequest): Promise<ITableauTokenResponse> {
        const self = this

        return new Promise<ITableauTokenResponse>((resolve, reject) => {


            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'PATableauToken';
            else
                sEndPoint += '/PATableauToken';

            axios.get(sEndPoint, {params: aRequest})
                .then((resp: any) => {
                    let responseData = resp.data;

                    if (!_.isEmpty(responseData)) {
                        resolve(responseData);
                    } else {
                        reject('Unable to get a token');
                    }
                })
                .catch((err: any) => {
                    reject('Unable to get a token. ' + err);
                });

        })
    }


    getToken(): Promise<any> {
        const self = this

        return new Promise<any>((resolve, error) => {
            let aUsrCtx = <IUsrContext>PAEnvironment.getValue(PAEnvironment.UserContext)

            switch (self._type) {
                case"Tableau":
                    self.makeTableauRequest({
                        email: aUsrCtx.User.cif.AUTHUSR_LOGIN,
                        userId: aUsrCtx.User.cif.AUTHUSR_ID
                    }).then((results: any) => {
                        resolve(results)
                    }).catch((err) => {
                        error(err)
                    })
                    break;
                default:
                    resolve()
            }

        })
    }

}